import type {
  FuelScaleCriteria,
  FuelScaleDetail,
} from "../../hooks/react-query/backOffice/useFuelScales";

export const mockFuelScales = {
  fuelScales: [
    {
      id: 4197,
      code: "17881",
      longDescription: "Last Diesel Monday of Month Effective Following Month",
      fuelPrice: "NATIONAL",
      fuelPriceValue: "3.62",
      status: "Active",
    },
    {
      id: 4198,
      code: "17882",
      longDescription: "Last Diesel Monday of Month Effective Following Month",
      fuelPrice: "PADD5",
      fuelPriceValue: "3.62",
      status: "Active",
    },
    {
      id: 4199,
      code: "17883",
      longDescription: "PaddV Average of Monday Effective Wednesday",
      fuelPrice: "PADD4",
      fuelPriceValue: "3.62",
      status: "Active",
    },
    {
      id: 4200,
      code: "17884",
      longDescription: "Nati Diesel Average Effective Following Monday",
      fuelPrice: "PADD4",
      fuelPriceValue: "3.62",
      status: "Active",
    },
    {
      id: 4201,
      code: "17885",
      longDescription: "Last Diesel Monday of Month Effective Following Month",
      fuelPrice: "PADD3",
      fuelPriceValue: "3.62",
      status: "Draft",
    },
    {
      id: 4202,
      code: "17886",
      longDescription: "PaddV Average of Monday Effective Wednesday",
      fuelPrice: "NATIONAL",
      fuelPriceValue: "3.62",
      status: "Active",
    },
    {
      id: 4203,
      code: "17887",
      longDescription: "Nati Diesel Average Effective",
      fuelPrice: "PADD4",
      fuelPriceValue: "3.62",
      status: "Inactive",
    },
    {
      id: 4204,
      code: "17888",
      longDescription: "Nati Diesel Average Effective Following Monday",
      fuelPrice: "PADD4",
      fuelPriceValue: "3.62",
      status: "Inactive",
    },
    {
      id: 4205,
      code: "17889",
      longDescription: "Last Diesel Monday of Month Effective Following Month",
      fuelPrice: "PADD3",
      fuelPriceValue: "3.62",
      status: "Active",
    },
    {
      id: 4206,
      code: "17890",
      longDescription: "PaddV Average of Monday Effective Wednesday",
      fuelPrice: "NATIONAL",
      fuelPriceValue: "3.62",
      status: "Draft",
    },
    {
      id: 4207,
      code: "17891",
      longDescription: "Last Diesel Monday of Month Effective Following Month",
      fuelPrice: "NATIONAL",
      fuelPriceValue: "3.62",
      status: "Active",
    },
    {
      id: 4208,
      code: "17892",
      longDescription: "Last Diesel Monday of Month Effective Following Month",
      fuelPrice: "PADD5",
      fuelPriceValue: "3.62",
      status: "Active",
    },
    {
      id: 4209,
      code: "17893",
      longDescription: "PaddV Average of Monday Effective Wednesday",
      fuelPrice: "PADD4",
      fuelPriceValue: "3.62",
      status: "Active",
    },
    {
      id: 4210,
      code: "17894",
      longDescription: "Nati Diesel Average Effective Following Monday",
      fuelPrice: "PADD4",
      fuelPriceValue: "3.62",
      status: "Active",
    },
    {
      id: 4211,
      code: "17895",
      longDescription: "Last Diesel Monday of Month Effective Following Month",
      fuelPrice: "PADD3",
      fuelPriceValue: "3.62",
      status: "Draft",
    },
  ],
  pagination: {
    totalRecords: 10,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
  },
  // Common accounts data used for all fuel scale codes
  commonAccounts: [
    {
      accountId: 1001,
      accountName: "ABC Logistics Inc",
      accountNumber: "ACC001",
    },
    {
      accountId: 1002,
      accountName: "XYZ Transport Co",
      accountNumber: "ACC002",
    },
    {
      accountId: 1003,
      accountName: "Global Shipping LLC",
      accountNumber: "ACC003",
    },
    {
      accountId: 1004,
      accountName: "Fast Freight Systems",
      accountNumber: "ACC004",
    },
    {
      accountId: 1005,
      accountName: "Regional Delivery Services",
      accountNumber: "ACC005",
    },
    {
      accountId: 1006,
      accountName: "West Coast Logistics",
      accountNumber: "ACC101",
    },
    {
      accountId: 1007,
      accountName: "Pacific Transport",
      accountNumber: "ACC102",
    },
    {
      accountId: 1008,
      accountName: "Mountain Express",
      accountNumber: "ACC103",
    },
    {
      accountId: 1009,
      accountName: "Monthly Shipping Co",
      accountNumber: "ACC201",
    },
    {
      accountId: 1010,
      accountName: "Regular Freight Inc",
      accountNumber: "ACC202",
    },
    {
      accountId: 1011,
      accountName: "Standard Logistics",
      accountNumber: "ACC203",
    },
    {
      accountId: 1012,
      accountName: "Monthly Express",
      accountNumber: "ACC204",
    },
    {
      accountId: 1013,
      accountName: "Consistent Transport",
      accountNumber: "ACC205",
    },
    {
      accountId: 1014,
      accountName: "Steady Shipping LLC",
      accountNumber: "ACC206",
    },
    {
      accountId: 1015,
      accountName: "Weekly Express Inc",
      accountNumber: "ACC301",
    },
    {
      accountId: 1016,
      accountName: "Fast Weekly Shipping",
      accountNumber: "ACC302",
    },
    {
      accountId: 1017,
      accountName: "Weekly Logistics Co",
      accountNumber: "ACC303",
    },
    {
      accountId: 1018,
      accountName: "Rapid Weekly Transport",
      accountNumber: "ACC304",
    },
    {
      accountId: 1019,
      accountName: "Quarterly Logistics Inc",
      accountNumber: "ACC401",
    },
    {
      accountId: 1020,
      accountName: "Quarterly Transport Co",
      accountNumber: "ACC402",
    },
  ],
  // Common history data for fuel scale price changes
  commonHistory: [
    {
      id: 1,
      price: "3.62",
      effectiveDate: "01/15/2024",
    },
    {
      id: 2,
      price: "3.58",
      effectiveDate: "02/01/2024",
    },
    {
      id: 3,
      price: "3.65",
      effectiveDate: "02/15/2024",
    },
    {
      id: 4,
      price: "3.72",
      effectiveDate: "03/01/2024",
    },
    {
      id: 5,
      price: "3.68",
      effectiveDate: "03/15/2024",
    },
    {
      id: 6,
      price: "3.75",
      effectiveDate: "04/01/2024",
    },
    {
      id: 7,
      price: "3.82",
      effectiveDate: "04/15/2024",
    },
    {
      id: 8,
      price: "3.79",
      effectiveDate: "05/01/2024",
    },
  ],
};

export const mockFuelPriceListOptions = [
  { id: 11, displayName: "California", fuelPriceValue: "6.096" },
  { id: 1, displayName: "National", fuelPriceValue: "4.859" },
  { id: 2, displayName: "PADD1", fuelPriceValue: "4.901" },
  { id: 3, displayName: "PADD1A", fuelPriceValue: "4.97" },
  { id: 4, displayName: "PADD1B", fuelPriceValue: "4.94" },
  { id: 5, displayName: "PADD1C", fuelPriceValue: "4.88" },
  { id: 6, displayName: "PADD2", fuelPriceValue: "4.801" },
  { id: 7, displayName: "PADD3", fuelPriceValue: "4.627" },
  { id: 8, displayName: "PADD4", fuelPriceValue: "4.397" },
  { id: 9, displayName: "PADD5", fuelPriceValue: "5.556" },
  { id: 10, displayName: "PADD5 Except California", fuelPriceValue: "5.088" },
];

export const mockServiceLevelOptions = [
  { id: 3, code: "LTL", description: "Standard LTL Freight" },
  { id: 1, code: "LTL-CC", description: "LTL Critical Care Freight" },
  { id: 2, code: "LTL-UC", description: "LTL Urgent Care Freight" },
  { id: 5, code: "AIR", description: "Air Freight" },
  { id: 4, code: "VOLUME", description: "Volume Freight" },
  { id: 6, code: "TRUCKLOAD", description: "Truckload Freight" },
];

// Mock detailed fuel surcharge code data
// Each entry uses the fuel scale ID as key and matches the FuelScaleDetail type
export const mockFuelSurchargeCodeDetails: Record<number, FuelScaleDetail> = {
  4197: {
    code: "17881",
    shortDescription: "Fuel Surcharge",
    longDescription: "Fuel Surcharge",
    fuelPrice: "NATIONAL",
    fuelPriceValue: "3.62",
    serviceLevel: ["LTL"],
    createdDate: "11/5/2025",
    recurrence: "Weekly",
    occursOn: "Monday",
    weekNumber: ["1", "3"],
    status: "Active",
    interlinerCharges: true,
    criteriaId: 12,
    numberOfGroups: 2,
    numberOfSequences: 3,
    rates: [
      { priceFrom: "1.69", priceTo: "1.699", percentage: "17.2" },
      { priceFrom: "1.7", priceTo: "1.799", percentage: "17.3" },
      { priceFrom: "1.8", priceTo: "1.899", percentage: "17.4" },
      { priceFrom: "1.9", priceTo: "1.999", percentage: "17.5" },
      { priceFrom: "2.0", priceTo: "2.099", percentage: "17.6" },
    ],
  },
  4198: {
    code: "17882",
    shortDescription: "Regional West Fuel",
    longDescription: "Regional West Fuel",
    fuelPrice: "PADD5",
    fuelPriceValue: "3.62",
    serviceLevel: ["LTL", "TL"],
    createdDate: "10/15/2024",
    recurrence: "Monthly",
    occursOn: "Tuesday",
    weekNumber: [],
    status: "Active",
    interlinerCharges: true,
    criteriaId: 13,
    numberOfGroups: 1,
    numberOfSequences: 1,
    rates: [
      { priceFrom: "1.5", priceTo: "1.599", percentage: "15.5" },
      { priceFrom: "1.6", priceTo: "1.699", percentage: "16.5" },
      { priceFrom: "1.7", priceTo: "1.799", percentage: "17.5" },
    ],
  },
  4199: {
    code: "17883",
    shortDescription: "Alternative Fuel 001",
    longDescription: "Alternative Fuel 001",
    fuelPrice: "PADD4",
    fuelPriceValue: "3.62",
    serviceLevel: ["LTL"],
    createdDate: "9/20/2024",
    recurrence: "Weekly",
    occursOn: "Wednesday",
    weekNumber: [],
    status: "Active",
    interlinerCharges: false,
    criteriaId: 14,
    numberOfGroups: 1,
    numberOfSequences: 1,
    rates: [
      { priceFrom: "1.6", priceTo: "1.699", percentage: "16" },
      { priceFrom: "1.7", priceTo: "1.799", percentage: "17" },
      { priceFrom: "1.8", priceTo: "1.899", percentage: "18" },
    ],
  },
  4200: {
    code: "17884",
    shortDescription: "Alternative Fuel 002",
    longDescription: "Alternative Fuel 002",
    fuelPrice: "PADD4",
    fuelPriceValue: "3.62",
    serviceLevel: ["LTL", "TL"],
    createdDate: "8/10/2024",
    recurrence: "Monthly",
    occursOn: "Thursday",
    weekNumber: ["2", "4"],
    status: "Active",
    interlinerCharges: true,
    criteriaId: 15,
    numberOfGroups: 1,
    numberOfSequences: 1,
    rates: [
      { priceFrom: "1.5", priceTo: "1.599", percentage: "15" },
      { priceFrom: "1.6", priceTo: "1.699", percentage: "16" },
      { priceFrom: "1.7", priceTo: "1.799", percentage: "17" },
      { priceFrom: "1.8", priceTo: "1.899", percentage: "18" },
    ],
  },
  4201: {
    code: "17885",
    shortDescription: "Fuel Surcharge 02",
    longDescription: "Fuel Surcharge 02",
    fuelPrice: "PADD3",
    fuelPriceValue: "3.62",
    serviceLevel: ["LTL"],
    createdDate: "7/5/2024",
    recurrence: "Weekly",
    occursOn: "Friday",
    weekNumber: [],
    status: "Active",
    interlinerCharges: true,
    criteriaId: 16,
    numberOfGroups: 1,
    numberOfSequences: 1,
    rates: [
      { priceFrom: "1.69", priceTo: "1.699", percentage: "17.2" },
      { priceFrom: "1.7", priceTo: "1.799", percentage: "17.3" },
      { priceFrom: "1.8", priceTo: "1.899", percentage: "17.4" },
    ],
  },
  4202: {
    code: "17886",
    shortDescription: "West Fuel 02",
    longDescription: "West Fuel 02",
    fuelPrice: "NATIONAL",
    fuelPriceValue: "3.62",
    serviceLevel: ["LTL"],
    createdDate: "6/15/2024",
    recurrence: "Monthly",
    occursOn: "Monday",
    weekNumber: [],
    status: "Active",
    interlinerCharges: true,
    criteriaId: 17,
    numberOfGroups: 1,
    numberOfSequences: 1,
    rates: [
      { priceFrom: "1.5", priceTo: "1.599", percentage: "15" },
      { priceFrom: "1.6", priceTo: "1.699", percentage: "16" },
    ],
  },
  4203: {
    code: "17887",
    shortDescription: "Fuel Surcharge 03",
    longDescription: "Fuel Surcharge 03",
    fuelPrice: "PADD4",
    fuelPriceValue: "3.62",
    serviceLevel: ["LTL", "TL"],
    createdDate: "5/20/2024",
    recurrence: "Weekly",
    occursOn: "Tuesday",
    weekNumber: [],
    status: "Inactive",
    interlinerCharges: true,
    criteriaId: 18,
    numberOfGroups: 1,
    numberOfSequences: 1,
    rates: [
      { priceFrom: "1.7", priceTo: "1.799", percentage: "17" },
      { priceFrom: "1.8", priceTo: "1.899", percentage: "18" },
      { priceFrom: "1.9", priceTo: "1.999", percentage: "19" },
    ],
  },
  4204: {
    code: "17888",
    shortDescription: "West Fuel 03",
    longDescription: "West Fuel 03",
    fuelPrice: "PADD4",
    fuelPriceValue: "3.62",
    serviceLevel: ["LTL"],
    createdDate: "4/10/2024",
    recurrence: "Monthly",
    occursOn: "Wednesday",
    weekNumber: [],
    status: "Inactive",
    interlinerCharges: false,
    criteriaId: 19,
    numberOfGroups: 1,
    numberOfSequences: 1,
    rates: [
      { priceFrom: "1.6", priceTo: "1.699", percentage: "16.5" },
      { priceFrom: "1.7", priceTo: "1.799", percentage: "17.5" },
    ],
  },
  4205: {
    code: "17889",
    shortDescription: "Fuel Surcharge 04",
    longDescription: "Fuel Surcharge 04",
    fuelPrice: "PADD3",
    fuelPriceValue: "3.62",
    serviceLevel: ["LTL", "TL", "Express"],
    createdDate: "3/15/2024",
    recurrence: "Weekly",
    occursOn: "Thursday",
    weekNumber: ["1", "2", "3"],
    status: "Active",
    interlinerCharges: true,
    criteriaId: 20,
    numberOfGroups: 1,
    numberOfSequences: 1,
    rates: [
      { priceFrom: "1.8", priceTo: "1.899", percentage: "18" },
      { priceFrom: "1.9", priceTo: "1.999", percentage: "19" },
      { priceFrom: "2.0", priceTo: "2.099", percentage: "20" },
    ],
  },
  4192: {
    code: "17890",
    shortDescription: "Thursday Fuel 001",
    longDescription: "Thursday Fuel 001",
    fuelPrice: "NATIONAL",
    fuelPriceValue: "3.62",
    serviceLevel: ["LTL"],
    createdDate: "2/25/2024",
    recurrence: "Monthly",
    occursOn: "Friday",
    weekNumber: [],
    status: "Draft",
    interlinerCharges: true,
    criteriaId: 21,
    numberOfGroups: 1,
    numberOfSequences: 1,
    rates: [
      { priceFrom: "1.4", priceTo: "1.499", percentage: "14" },
      { priceFrom: "1.5", priceTo: "1.599", percentage: "15" },
    ],
  },
};

// Mock criteria data for fuel scales
// Each entry uses criteriaId as key and matches the viewCriteriaSchema structure
export const mockFuelScaleCriteria: Record<number, FuelScaleCriteria> = {
  12: {
    groups: [
      {
        sequences: [
          {
            tableName: "Client",
            fieldName: "State",
            startLookup: "Shipper",
            endLookup: "Consignee",
            startMin: "CA, OR, WA",
            startMax: "CA, OR, WA",
            endMin: "CA, OR, WA",
            endMax: "CA, OR, WA",
            startLogic: "Like",
            endLogic: "Like",
            groupLogic: "Not Like",
            reverseRange: true,
          },
          {
            tableName: "Client",
            fieldName: "State",
            startLookup: "Shipper",
            endLookup: "Consignee",
            startMin: "CA, OR, WA",
            startMax: "CA, OR, WA",
            endMin: "CA, OR, WA",
            endMax: "CA, OR, WA",
            startLogic: "Like",
            endLogic: "Like",
            groupLogic: "Not Like",
            reverseRange: true,
          },
        ],
      },
      {
        sequences: [
          {
            tableName: "SHIPMENT",
            fieldName: "WEIGHT",
            startLookup: "Origin",
            endLookup: "Destination",
            startMin: "100",
            startMax: "500",
            endMin: "200",
            endMax: "600",
            startLogic: ">=",
            endLogic: "<=",
            groupLogic: "AND",
            reverseRange: false,
          },
        ],
      },
    ],
  },
  13: {
    groups: [
      {
        sequences: [
          {
            tableName: "SHIPMENT",
            fieldName: "WEIGHT",
            startLookup: "Origin",
            endLookup: "Destination",
            startMin: "100",
            startMax: "500",
            endMin: "200",
            endMax: "600",
            startLogic: ">=",
            endLogic: "<=",
            groupLogic: "AND",
            reverseRange: false,
          },
        ],
      },
    ],
  },
  14: {
    groups: [
      {
        sequences: [
          {
            tableName: "CLIENT",
            fieldName: "CLIENT_CODE",
            startLookup: "Shipper",
            endLookup: "Consignee",
            startMin: "ACC001",
            startMax: "ACC005",
            endMin: "ACC002",
            endMax: "ACC006",
            startLogic: "in",
            endLogic: "in",
            groupLogic: "OR",
            reverseRange: false,
          },
        ],
      },
    ],
  },
  15: {
    groups: [
      {
        sequences: [
          {
            tableName: "DETAIL",
            fieldName: "COMMODITY_CLASS",
            startLookup: "Origin",
            endLookup: "Destination",
            startMin: "50",
            startMax: "100",
            endMin: "60",
            endMax: "110",
            startLogic: "between",
            endLogic: "between",
            groupLogic: "AND",
            reverseRange: false,
          },
        ],
      },
    ],
  },
  16: {
    groups: [
      {
        sequences: [
          {
            tableName: "CLIENT",
            fieldName: "ACCOUNT_NUMBER",
            startLookup: "Shipper",
            endLookup: "Consignee",
            startMin: "ACC",
            startMax: "ACC",
            endMin: "ACC",
            endMax: "ACC",
            startLogic: "like",
            endLogic: "like",
            groupLogic: "OR",
            reverseRange: true,
          },
        ],
      },
    ],
  },
  17: {
    groups: [
      {
        sequences: [
          {
            tableName: "SHIPMENT",
            fieldName: "DISTANCE",
            startLookup: "Origin",
            endLookup: "Destination",
            startMin: "100",
            startMax: "500",
            endMin: "200",
            endMax: "600",
            startLogic: ">",
            endLogic: "<",
            groupLogic: "AND",
            reverseRange: false,
          },
        ],
      },
    ],
  },
  18: {
    groups: [
      {
        sequences: [
          {
            tableName: "CLIENT",
            fieldName: "CLIENT_NAME",
            startLookup: "Shipper",
            endLookup: "Consignee",
            startMin: "ABC",
            startMax: "XYZ",
            endMin: "DEF",
            endMax: "UVW",
            startLogic: "contains",
            endLogic: "contains",
            groupLogic: "OR",
            reverseRange: false,
          },
        ],
      },
    ],
  },
  19: {
    groups: [
      {
        sequences: [
          {
            tableName: "SERVICE CENTER",
            fieldName: "SERVICE_CENTER_CODE",
            startLookup: "Origin",
            endLookup: "Destination",
            startMin: "111",
            startMax: "222",
            endMin: "333",
            endMax: "444",
            startLogic: "=",
            endLogic: "=",
            groupLogic: "AND",
            reverseRange: false,
          },
        ],
      },
    ],
  },
  20: {
    groups: [
      {
        sequences: [
          {
            tableName: "SHIPMENT",
            fieldName: "ORIGIN_ZIP",
            startLookup: "Origin",
            endLookup: "Destination",
            startMin: "75001",
            startMax: "75099",
            endMin: "75201",
            endMax: "75299",
            startLogic: "between",
            endLogic: "between",
            groupLogic: "AND",
            reverseRange: false,
          },
        ],
      },
    ],
  },
  21: {
    groups: [
      {
        sequences: [
          {
            tableName: "RATE GROUP",
            fieldName: "RATE_GROUP_CODE",
            startLookup: "Shipper",
            endLookup: "Consignee",
            startMin: "RG001",
            startMax: "RG005",
            endMin: "RG002",
            endMax: "RG006",
            startLogic: "in",
            endLogic: "in",
            groupLogic: "OR",
            reverseRange: true,
          },
        ],
      },
    ],
  },
};
